"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATING_VOTE_VALUES = void 0;
exports.buildRatingResultsPayload = buildRatingResultsPayload;
exports.RATING_VOTE_VALUES = new Set(['1', '2', '3', '4', '5']);
/**
 * Build the structured payload for `<Rating-Results>`.
 * Only slots whose value is `"1"`–`"5"` count; missing keys and other strings are ignored.
 * Average is the exact float mean (e.g. 4.5), not rounded to nearest 0.5.
 */
function buildRatingResultsPayload(map, resolvePortrait, resolveDisplayName) {
    const votes = [];
    for (const [character, value] of Object.entries(map)) {
        if (!character || !exports.RATING_VOTE_VALUES.has(value)) {
            continue;
        }
        const portrait = (resolvePortrait(character) || 'generic').trim() || 'generic';
        const displayName = (resolveDisplayName?.(character) || character).trim() || character;
        votes.push({ character, displayName, portrait, value });
    }
    votes.sort((a, b) => a.displayName.localeCompare(b.displayName));
    const count = votes.length;
    const average = count === 0 ? 0 : votes.reduce((sum, vote) => sum + Number(vote.value), 0) / count;
    return { average, count, votes };
}
//# sourceMappingURL=ratingResults.js.map